module.exports = __webpack_public_path__ + "img/ir.407bdd9.webp";